/**
 * Resize the curve SVGs proportionally
 * based on their current height/window width
 *
 * @param selectors
 * @return void
 */
const resizeCurves = (selectors) => {
  let sections = document.querySelectorAll(selectors);
  if(sections){
    sections.forEach((section) => {
      let curves = section.querySelectorAll('.curved-edge');
      if(curves){
        curves.forEach((curve) => {
          let curveHeight = curve.clientHeight;
          if(curve.classList.contains('curved-edge--inverted')){
            curve.style.bottom = -(curveHeight - 2);
          }else{
            curve.style.top = -(curveHeight - 2);
          }
        });
      }
    });
  }
}

/**
 * Set the curved edge heights
 * for specific HTML sections/nodes
 * @return void
 */
const setCurvedEdgeHeights = () => {
  // sections elements with curved edges
  const selectors = '.section-medical-experts, .section-navigation';
  resizeCurves(selectors);
  window.addEventListener('resize', () => {
    resizeCurves(selectors);
  });
}

export { setCurvedEdgeHeights }
